import React, { useState } from 'react';

export default function NotasModal({ initialNota, initialPrivacidad, onSave, onClose, loading }) {
  const [nota, setNota] = useState(initialNota || '');
  const [privada, setPrivada] = useState(initialPrivacidad === false ? false : true);
  const [error, setError] = useState(null);

  const handleSave = () => {
    if (!nota.trim()) {
      setError('La nota no puede estar vacía.');
      return;
    }
    setError(null);
    onSave({ nota, privada });
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0,0,0,0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 16,
        padding: 32,
        minWidth: 340,
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      }}>
        <h2 style={{ color: '#0099cc', marginBottom: 16 }}>Notas personales</h2>
        <textarea
          value={nota}
          onChange={e => setNota(e.target.value)}
          rows={6}
          style={{
            borderRadius: 8,
            border: '1px solid #b0bec5',
            padding: 12,
            fontSize: 16,
            marginBottom: 16,
            resize: 'vertical'
          }}
          placeholder="Escribe tus notas aquí..."
        />
        <label style={{ marginBottom: 16, display: 'flex', alignItems: 'center', fontSize: 15 }}>
          <input
            type="checkbox"
            checked={privada}
            onChange={e => setPrivada(e.target.checked)}
            style={{ marginRight: 8 }}
          />
          Permitir que mi neuroterapeuta y superadmin vean estas notas
        </label>
        {error && <div style={{ color: '#e53935', marginBottom: 8 }}>{error}</div>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button
            onClick={onClose}
            style={{
              background: '#b0bec5',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: '10px 20px',
              fontSize: 15,
              cursor: 'pointer'
            }}
            disabled={loading}
          >Cancelar</button>
          <button
            onClick={handleSave}
            style={{
              background: '#0099cc',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: '10px 20px',
              fontSize: 15,
              fontWeight: 600,
              cursor: 'pointer'
            }}
            disabled={loading}
          >{loading ? 'Guardando...' : 'Guardar'}</button>
        </div>
      </div>
    </div>
  );
}
